import React, { useState } from 'react'
import {
  Box,
  Button,
  Divider,
  Flex,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react'
import { StaticQuery, graphql } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronSquareDown,
  faChevronSquareUp,
} from '@fortawesome/pro-regular-svg-icons'

const MegaFooter = props => {
  const [isFooterOn, setFooterOn] = useState(false)
  const toggleFooter = () => setFooterOn(!isFooterOn)
  return (
    <StaticQuery
      query={graphql`
        {
          datoCmsWvumfooter {
            id
            section {
              id
              linksNode {
                childMarkdownRemark {
                  html
                }
              }
              section
            }
          }
          allDatoCmsHospital(sort: { fields: position }) {
            edges {
              node {
                hospitalName
                id
                position
                websiteUrl
              }
            }
          }
          allDatoCmsInstitute(sort: { fields: position }) {
            edges {
              node {
                instituteName
                id
                position
                websiteUrl
              }
            }
          }
        }
      `}
      render={data => (
        <>
          <Box px={[0, 0, 0, 6]} pb={6} width="full">
            <Button
              aria-label={`${
                isFooterOn ? 'close footer menu' : 'open footer menu'
              }`}
              id="megamenu"
              variant="outline"
              fontFamily="body"
              onClick={toggleFooter}
              display="flex"
              verticalAlign="center"
              colorScheme="blue"
            >
              <Box as="span" mr={3}>
                WVU Medicine Network
              </Box>
              {isFooterOn ? (
                <FontAwesomeIcon icon={faChevronSquareUp} fontSize="lg" />
              ) : (
                <FontAwesomeIcon icon={faChevronSquareDown} fontSize="lg" />
              )}
            </Button>
          </Box>

          <Box
            px={[0, 0, 0, 6]}
            width="full"
            sx={{
              display: isFooterOn ? 'block' : 'none',
              visibility: isFooterOn ? 'visible' : 'hidden',
              opacity: isFooterOn ? 1 : 0,
              transition: `opacity 0.25s, visibility 0.25s`,
            }}
          >
            <Divider mb={6} borderColor="blackAlpha.200" />
            <Flex
              mx={[0, 0, 0, -6]}
              flexWrap="wrap"
              justifyContent="space-between"
              sx={{ '*': { fontSize: 'sm' } }}
            >
              <Box px={[0, 0, 2, 6]} width={['full', 'full', '50%', 1 / 4]}>
                {/* Patients & Visitors */}
                {data.datoCmsWvumfooter.section
                  .map(({ id, linksNode, section }) => (
                    <Box key={id}>
                      <Box fontSize="sm" fontWeight="bold" marginBottom={2}>
                        {section
                          .toString()
                          .replace(/[\|\$%@"<>\(\)\+\[\],]/g, '')}
                      </Box>
                      <Box
                        width="full"
                        sx={{
                          ul: {
                            listStyle: 'none',
                            margin: '0 0 2rem 0',
                            padding: 0,
                          },
                          li: {
                            marginBottom: `calc(1.45rem / 2.5)`,
                          },
                          'li a': {
                            color: 'text',
                            textDecoration: 'none',
                          },
                          'li a:hover': {
                            textDecoration: 'underline',
                          },
                        }}
                        dangerouslySetInnerHTML={{
                          __html: linksNode.childMarkdownRemark.html,
                        }}
                      />
                    </Box>
                  ))
                  .slice(0, 1)}
              </Box>

              <Box px={[0, 0, 2, 6]} width={['full', 'full', '50%', 1 / 4]}>
                {/* For Medical Professionals */}
                {data.datoCmsWvumfooter.section
                  .map(({ id, linksNode, section }) => (
                    <Box key={id}>
                      <Box fontSize="sm" fontWeight="bold" marginBottom={2}>
                        {section
                          .toString()
                          .replace(/[\|&;\$%@"<>\(\)\+\[\],]/g, '')}
                      </Box>
                      <Box
                        width="full"
                        sx={{
                          ul: {
                            listStyle: 'none',
                            margin: '0 0 2rem 0',
                            padding: 0,
                          },
                          li: {
                            marginBottom: `calc(1.45rem / 2.5)`,
                          },
                          'li a': {
                            color: 'text',
                            textDecoration: 'none',
                          },
                          'li a:hover': {
                            textDecoration: 'underline',
                          },
                        }}
                        dangerouslySetInnerHTML={{
                          __html: linksNode.childMarkdownRemark.html,
                        }}
                      />
                    </Box>
                  ))
                  .slice(1, 2)}
              </Box>

              <Box px={[0, 0, 2, 6]} width={['full', 'full', '50%', 1 / 4]}>
                {/* Community */}
                {data.datoCmsWvumfooter.section
                  .map(({ id, linksNode, section }) => (
                    <Box key={id}>
                      <Box fontSize="sm" fontWeight="bold" marginBottom={2}>
                        {section
                          .toString()
                          .replace(/[\|&;\$%@"<>\(\)\+\[\],]/g, '')}
                      </Box>
                      <Box
                        width="full"
                        sx={{
                          ul: {
                            listStyle: 'none',
                            margin: '0 0 2rem 0',
                            padding: 0,
                          },
                          li: {
                            marginBottom: `calc(1.45rem / 2.5)`,
                          },
                          'li a': {
                            color: 'text',
                            textDecoration: 'none',
                          },
                          'li a:hover': {
                            textDecoration: 'underline',
                          },
                        }}
                        dangerouslySetInnerHTML={{
                          __html: linksNode.childMarkdownRemark.html,
                        }}
                      />
                    </Box>
                  ))
                  .slice(2, 3)}
              </Box>

              <Box px={[0, 0, 2, 6]} width={['full', 'full', '50%', 1 / 4]}>
                {/* About WVU Medicine */}
                {data.datoCmsWvumfooter.section
                  .map(({ id, linksNode, section }) => (
                    <Box key={id}>
                      <Box fontSize="sm" fontWeight="bold" marginBottom={2}>
                        {section
                          .toString()
                          .replace(/[\|&;\$%@"<>\(\)\+\[\],]/g, '')}
                      </Box>
                      <Box
                        width="full"
                        sx={{
                          ul: {
                            listStyle: 'none',
                            margin: '0 0 2rem 0',
                            padding: 0,
                          },
                          li: {
                            marginBottom: `calc(1.45rem / 2.5)`,
                          },
                          'li a': {
                            color: 'text',
                            textDecoration: 'none',
                          },
                          'li a:hover': {
                            textDecoration: 'underline',
                          },
                        }}
                        dangerouslySetInnerHTML={{
                          __html: linksNode.childMarkdownRemark.html,
                        }}
                      />
                    </Box>
                  ))
                  .slice(3, 4)}
              </Box>
            </Flex>
          </Box>
        </>
      )}
    ></StaticQuery>
  )
}

export default MegaFooter
